export interface InfiniteScrollableViewModel {
    loadAdditionalPage?: Function,
    tryFetchPage?: Function
}

export function onScrollInfiniteScroll(viewModel: InfiniteScrollableViewModel, event: Event): void {
    let scrollElement: Element = <Element>event.currentTarget;
    if ((scrollElement.scrollTop + scrollElement.clientHeight >= (scrollElement.scrollHeight * 0.8))) {
        if (typeof viewModel.loadAdditionalPage === "function") { // grid.js
            viewModel.loadAdditionalPage();
        } else if (typeof viewModel.tryFetchPage === "function") { // Views die tryFetchPage hebben geimplementeerd
            viewModel.tryFetchPage();
        }
    }
}

export function doesViewExist(id: string): boolean {
    return document.getElementById(id) !== null;
}